import { render, staticRenderFns } from "./invoiceDetail.vue?vue&type=template&id=066d2ecf&scoped=true"
import script from "./invoiceDetail.vue?vue&type=script&lang=js"
export * from "./invoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./invoiceDetail.vue?vue&type=style&index=0&id=066d2ecf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d2ecf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066d2ecf')) {
      api.createRecord('066d2ecf', component.options)
    } else {
      api.reload('066d2ecf', component.options)
    }
    module.hot.accept("./invoiceDetail.vue?vue&type=template&id=066d2ecf&scoped=true", function () {
      api.rerender('066d2ecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/invoiceDetail.vue"
export default component.exports